import SearchFilterBar from '../../components/ui/search-filter-bar';
import { optionsUsers } from '../../data/group-insurance';
import UserListThead from '../../components/module/user-management/user-list-thead';
import UserListTbody from '../../components/module/user-management/user-list-tbody';
import { useDispatch, useSelector } from 'react-redux';
import UserInfoModal from '../../components/module/user-management/modal/user-information/user-info-modal';
import { useFilteredUsers } from '../../hooks/filter/use-filteredUsers';
import SectionHeader from '../../components/ui/section-header';
import { selectSearchTypeState, selectSearchValueState, setSearchControl } from '../../features/it-user-forms/user-forms-slice';
import { useUserTyping } from '../../hooks/effect/use-user-typing';
import { DropdownOption } from '../../features/auth/auth-state';
import { getErrorMessage } from '../../utils/get-error-message.utils';
import { useGetUserListQuery } from '../../api/it/account/account-api';
import { useModalAccess } from '../../components/global/modal/use-modal-access';

export default function UserManagementPage() {

    const dispatch = useDispatch();
    const { isViewUser } = useModalAccess()
    const { 
        data: getUserList, 
        isLoading: isLoadingGetUserList, 
        isError: isErrorGetUserList, 
        error: errorGetUserList, 
        // refetch: refetchGetUserList, 
        // isFetching: isFetchingGetUserList 
    } = useGetUserListQuery();
    const errorMessageGetUserList = getErrorMessage(errorGetUserList)
    const isLoading = isLoadingGetUserList;

    const searchType = useSelector(selectSearchTypeState)
    const searchValue = useSelector(selectSearchValueState)
    
    useUserTyping()
    const userList = useFilteredUsers({
        users: getUserList,
        searchValue,
        searchType,
    });

    const normalizedOptions: DropdownOption[] = optionsUsers.map((s) => ({
        id: s.id,
        name: s.name,
    }));

    return (
        <div className="flex h-full min-h-0 w-full flex-col bg-[#f8fafc] rounded-xl border border-gray-200">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <SectionHeader
                    title='User Management'
                    subtitle='Manage and monitor user accounts and permissions.'
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
                            <circle cx="9" cy="8" r="3" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 20a6 6 0 0 1 12 0M17 11a3 3 0 1 0 0-6M18 14a5 5 0 0 1 3 4" />
                        </svg>
                    }
                />
                <div className="mx-auto flex min-h-0 w-full flex-1 flex-col gap-2 p-3">
                    <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
                        <div className="shrink-0 border-b border-gray-200 p-3">
                            <SearchFilterBar
                                searchType={searchType}
                                setSearchType={(value: DropdownOption) => dispatch(setSearchControl({ type: 'sType', value: value}))}
                                searchValue={searchValue}
                                setSearchValue={(value: string) => dispatch(setSearchControl({ type: 'sValue', value: value}))}
                                options={normalizedOptions}
                            />
                        </div>
                        <div className="min-h-0 flex-1 overflow-auto">
                            <table className="min-w-max w-full border-collapse">
                                <UserListThead />
                                <UserListTbody
                                    isLoading={isLoading}
                                    isError={isErrorGetUserList}
                                    errorMessage={errorMessageGetUserList}
                                    data={userList}
                                />
                            </table>
                        </div>
                    </div>
                    {/* <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                        {getProposal?.pagination && (
                            <div className="border-t border-gray-100 bg-gray-50/60 p-3 sm:p-4">
                                <Pagination
                                    setPage={setPage}
                                    handleReload={handleReload}
                                    pagination={getProposal.pagination}
                                    defaultTotalPages={defaultTotalPages}
                                    setDefaultTotalPages={handleChangePageSize}
                                    totalPagesOptions={proposalDefaultPageSize}
                                />
                            </div>
                        )}
                    </div> */}
                </div>
            </div>
            {isViewUser && (<UserInfoModal />)}
        </div>
    )
}